<template>
  <div class="password-input">
    <div class="input-wrapper">
      <input
        :type="showPassword ? 'text' : 'password'"
        id="password"
        v-model="v$.password.$model"
        @input="validatePassword"
        :class=" { 'error': v$.password.$invalid && password.length > 0}"
      />
      <button type="button" @click="togglePasswordVisibility">
          <svg v-if="!showPassword" width="20.000000" height="20.000000" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <defs>
                  <clipPath id="clip10_949">
                      <rect id="Icons" rx="0.000000" width="19.000000" height="19.000000" transform="translate(0.500000 0.500000)" fill="white" fill-opacity="0"/>
                  </clipPath>
              </defs>
              <rect id="Icons" rx="0.000000" width="19.000000" height="19.000000" transform="translate(0.500000 0.500000)" fill="#FFFFFF" fill-opacity="0"/>
              <g clip-path="url(#clip10_949)">
                  <path id="Vector" d="M17.5 11.25C17.5 8.88 14.14 5.41 10 5.41C5.85 5.41 2.5 8.88 2.5 11.25C2.5 13.61 5.85 17.08 10 17.08C14.14 17.08 17.5 13.61 17.5 11.25Z" stroke="#131A29" stroke-opacity="1.000000" stroke-width="1.250000" stroke-linejoin="round"/>
                  <path id="Vector" d="M12.5 11.25C12.5 9.86 11.38 8.75 10 8.75C8.61 8.75 7.5 9.86 7.5 11.25C7.5 12.63 8.61 13.75 10 13.75C11.38 13.75 12.5 12.63 12.5 11.25Z" stroke="#131A29" stroke-opacity="1.000000" stroke-width="1.250000" stroke-linejoin="round"/>
                  <path id="Vector" d="M5.52 4.69L6.6 6.2" stroke="#131A29" stroke-opacity="1.000000" stroke-width="1.250000" stroke-linecap="round"/>
                  <path id="Vector" d="M14.84 4.87L13.76 6.38" stroke="#131A29" stroke-opacity="1.000000" stroke-width="1.250000" stroke-linecap="round"/>
                  <path id="Vector" d="M10 2.91L10 5.41" stroke="#131A29" stroke-opacity="1.000000" stroke-width="1.250000" stroke-linecap="round"/>
              </g>
          </svg>
          <svg v-if="showPassword" width="20.000000" height="20.000000" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <defs>
                  <clipPath id="clip10_949">
                      <rect id="Icons" rx="0.000000" width="19.000000" height="19.000000" transform="translate(0.500000 0.500000)" fill="white" fill-opacity="0"/>
                  </clipPath>
              </defs>
              <rect id="Icons" rx="0.000000" width="19.000000" height="19.000000" transform="translate(0.500000 0.500000)" fill="#FFFFFF" fill-opacity="0"/>
              <g clip-path="url(#clip10_949)">
                  <path id="Vector" d="M17.5 11.25C17.5 8.88 14.14 5.41 10 5.41C5.85 5.41 2.5 8.88 2.5 11.25C2.5 13.61 5.85 17.08 10 17.08C14.14 17.08 17.5 13.61 17.5 11.25Z" stroke="#131A29" stroke-opacity="1.000000" stroke-width="1.250000" stroke-linejoin="round"/>
                  <path id="Vector" d="M12.5 11.25C12.5 9.86 11.38 8.75 10 8.75C8.61 8.75 7.5 9.86 7.5 11.25C7.5 12.63 8.61 13.75 10 13.75C11.38 13.75 12.5 12.63 12.5 11.25Z" stroke="#131A29" stroke-opacity="1.000000" stroke-width="1.250000" stroke-linejoin="round"/>
                  <path id="Vector" d="M5.52 4.69L6.6 6.2" stroke="#131A29" stroke-opacity="1.000000" stroke-width="1.250000" stroke-linecap="round"/>
                  <path id="Vector" d="M14.84 4.87L13.76 6.38" stroke="#131A29" stroke-opacity="1.000000" stroke-width="1.250000" stroke-linecap="round"/>
                  <path id="Vector" d="M10 2.91L10 5.41" stroke="#131A29" stroke-opacity="1.000000" stroke-width="1.250000" stroke-linecap="round"/>
              </g>
          </svg>
      </button>


    </div>

      <ul class="validation-messages">
          <li>
              <svg v-if="password.length == 0 || v$.password.minLength.$invalid"  width="12.916016" height="12.916748" viewBox="0 0 12.916 12.9167" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <defs/>
                  <path id="Vector" d="M10.58 10.58C11.63 9.52 12.29 8.06 12.29 6.45C12.29 4.84 11.63 3.38 10.58 2.33C9.52 1.27 8.06 0.62 6.45 0.62C4.84 0.62 3.38 1.27 2.33 2.33C1.27 3.38 0.62 4.84 0.62 6.45C0.62 8.06 1.27 9.52 2.33 10.58C3.38 11.63 4.84 12.29 6.45 12.29C8.06 12.29 9.52 11.63 10.58 10.58Z" stroke="#556272" stroke-opacity="1.000000" stroke-width="1.250000" stroke-linejoin="round"/>
              </svg>
              <svg v-if="password.length >= 1 && !v$.password.minLength.$invalid" width="14.000000" height="14.000000" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <defs>
                      <clipPath id="clip326_20902">
                          <rect id="Frame" rx="0.000000" width="13.000000" height="13.000000" transform="translate(0.500000 0.500000)" fill="white" fill-opacity="0"/>
                      </clipPath>
                  </defs>
                  <rect id="Frame" rx="0.000000" width="13.000000" height="13.000000" transform="translate(0.500000 0.500000)" fill="#FFFFFF" fill-opacity="0"/>
                  <g clip-path="url(#clip326_20902)">
                      <path id="Vector" d="M11.12 11.12C12.17 10.06 12.83 8.61 12.83 7C12.83 5.38 12.17 3.93 11.12 2.87C10.06 1.81 8.6 1.16 7 1.16C5.38 1.16 3.92 1.81 2.87 2.87C1.81 3.93 1.16 5.38 1.16 7C1.16 8.61 1.81 10.06 2.87 11.12C3.92 12.18 5.38 12.83 7 12.83C8.6 12.83 10.06 12.18 11.12 11.12Z" stroke="#050505" stroke-opacity="1.000000" stroke-width="1.250000" stroke-linejoin="round"/>
                      <path id="Vector" d="M4.66 7L6.41 8.75L9.91 5.25" stroke="#050505" stroke-opacity="1.000000" stroke-width="1.250000" stroke-linejoin="round" stroke-linecap="round"/>
                  </g>
              </svg>
              Password Length should be greater than 8
          </li>
          <li>
              <svg v-if="password.length == 0 || v$.password.hasCapitalLetter.$invalid"  width="12.916016" height="12.916748" viewBox="0 0 12.916 12.9167" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <defs/>
                  <path id="Vector" d="M10.58 10.58C11.63 9.52 12.29 8.06 12.29 6.45C12.29 4.84 11.63 3.38 10.58 2.33C9.52 1.27 8.06 0.62 6.45 0.62C4.84 0.62 3.38 1.27 2.33 2.33C1.27 3.38 0.62 4.84 0.62 6.45C0.62 8.06 1.27 9.52 2.33 10.58C3.38 11.63 4.84 12.29 6.45 12.29C8.06 12.29 9.52 11.63 10.58 10.58Z" stroke="#556272" stroke-opacity="1.000000" stroke-width="1.250000" stroke-linejoin="round"/>
              </svg>
              <svg v-if="password.length >= 1 && !v$.password.hasCapitalLetter.$invalid" width="14.000000" height="14.000000" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <defs>
                      <clipPath id="clip326_20902">
                          <rect id="Frame" rx="0.000000" width="13.000000" height="13.000000" transform="translate(0.500000 0.500000)" fill="white" fill-opacity="0"/>
                      </clipPath>
                  </defs>
                  <rect id="Frame" rx="0.000000" width="13.000000" height="13.000000" transform="translate(0.500000 0.500000)" fill="#FFFFFF" fill-opacity="0"/>
                  <g clip-path="url(#clip326_20902)">
                      <path id="Vector" d="M11.12 11.12C12.17 10.06 12.83 8.61 12.83 7C12.83 5.38 12.17 3.93 11.12 2.87C10.06 1.81 8.6 1.16 7 1.16C5.38 1.16 3.92 1.81 2.87 2.87C1.81 3.93 1.16 5.38 1.16 7C1.16 8.61 1.81 10.06 2.87 11.12C3.92 12.18 5.38 12.83 7 12.83C8.6 12.83 10.06 12.18 11.12 11.12Z" stroke="#050505" stroke-opacity="1.000000" stroke-width="1.250000" stroke-linejoin="round"/>
                      <path id="Vector" d="M4.66 7L6.41 8.75L9.91 5.25" stroke="#050505" stroke-opacity="1.000000" stroke-width="1.250000" stroke-linejoin="round" stroke-linecap="round"/>
                  </g>
              </svg>
              Minimum 1 CAPITAL LETTER in password
          </li>
          <li>
              <svg v-if="password.length == 0 || v$.password.hasDigit.$invalid"  width="12.916016" height="12.916748" viewBox="0 0 12.916 12.9167" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <defs/>
                  <path id="Vector" d="M10.58 10.58C11.63 9.52 12.29 8.06 12.29 6.45C12.29 4.84 11.63 3.38 10.58 2.33C9.52 1.27 8.06 0.62 6.45 0.62C4.84 0.62 3.38 1.27 2.33 2.33C1.27 3.38 0.62 4.84 0.62 6.45C0.62 8.06 1.27 9.52 2.33 10.58C3.38 11.63 4.84 12.29 6.45 12.29C8.06 12.29 9.52 11.63 10.58 10.58Z" stroke="#556272" stroke-opacity="1.000000" stroke-width="1.250000" stroke-linejoin="round"/>
              </svg>
              <svg v-if="password.length >= 1 && !v$.password.hasDigit.$invalid" width="14.000000" height="14.000000" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <defs>
                      <clipPath id="clip326_20902">
                          <rect id="Frame" rx="0.000000" width="13.000000" height="13.000000" transform="translate(0.500000 0.500000)" fill="white" fill-opacity="0"/>
                      </clipPath>
                  </defs>
                  <rect id="Frame" rx="0.000000" width="13.000000" height="13.000000" transform="translate(0.500000 0.500000)" fill="#FFFFFF" fill-opacity="0"/>
                  <g clip-path="url(#clip326_20902)">
                      <path id="Vector" d="M11.12 11.12C12.17 10.06 12.83 8.61 12.83 7C12.83 5.38 12.17 3.93 11.12 2.87C10.06 1.81 8.6 1.16 7 1.16C5.38 1.16 3.92 1.81 2.87 2.87C1.81 3.93 1.16 5.38 1.16 7C1.16 8.61 1.81 10.06 2.87 11.12C3.92 12.18 5.38 12.83 7 12.83C8.6 12.83 10.06 12.18 11.12 11.12Z" stroke="#050505" stroke-opacity="1.000000" stroke-width="1.250000" stroke-linejoin="round"/>
                      <path id="Vector" d="M4.66 7L6.41 8.75L9.91 5.25" stroke="#050505" stroke-opacity="1.000000" stroke-width="1.250000" stroke-linejoin="round" stroke-linecap="round"/>
                  </g>
              </svg>
              Minimum 1 digit in password
          </li>
      </ul>
  </div>
</template>

<script>
import { required, minLength, helpers } from '@vuelidate/validators';
import useVuelidate from '@vuelidate/core';

export default {
  setup: () => ({ v$: useVuelidate() }),
  props: {
    password: String,
  },
  data() {
    return {
      password: '',
      showPassword: false,
    };
  },
  validations() {
    return {
      password: {
        required,
        minLength: minLength(8),
        hasCapitalLetter: helpers.withMessage(
        'Password must contain at least one uppercase letter',
        value => /[A-Z]/.test(value)
          ),
          hasDigit: helpers.withMessage(
          'Password must contain at least one digit',
          value => /\d/.test(value)
          ),
      },
    };
  },
  methods: {
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
    validatePassword(event) {
      this.v$.password.$touch();
      this.$emit('update:password', this.password);
    },
  },
};
</script>

<style scoped>
.password-input {
  display: flex;
  flex-direction: column;
}
input:focus {
outline: none;/* если border тоже нужно убрать */
}
input{
  box-sizing: border-box;
  border: 1px solid rgb(222, 230, 234);
  border-radius: 8px;
  background: rgb(255, 255, 255);
  height: 44px;
  padding-left: 10px;
  width: 100%;
}
.input-wrapper {
  position: relative;
}

input {
  padding-right: 60px;
}
input.error{
  border: 1px solid red;
}
button {
  position: absolute;
  right: 11px;
  top: 0;
  height: 100%;
  border: none;
  background: transparent;
  cursor: pointer;
}

.validation-messages {
  margin-top: 10px;
  list-style: none;
  padding: 0;
}

.validation-messages li {
      color: rgb(85, 98, 114);
      font-family: Satoshi;
      font-size: 11px;
      font-weight: 500;
      line-height: 140%;
      letter-spacing: 0%;
      text-align: left;
      text-transform: uppercase;
}
</style>
